const CHUNK_RELOAD_KEY = 'muwarid-chunk-reload';

export function isChunkLoadError(error: unknown): boolean {
  const message =
    error instanceof Error
      ? error.message
      : typeof error === 'string'
        ? error
        : String((error as {message?: string})?.message ?? error ?? '');

  return (
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('Importing a module script failed') ||
    message.includes('Loading chunk') ||
    message.includes('ChunkLoadError')
  );
}

/** Reload once when a lazy chunk is missing (stale bundle after deploy). */
export function reloadOnChunkLoadError(error: unknown): void {
  if (!isChunkLoadError(error)) return;

  if (!sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
    sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
    window.location.reload();
    return;
  }

  sessionStorage.removeItem(CHUNK_RELOAD_KEY);
}

export function clearChunkReloadFlag(): void {
  sessionStorage.removeItem(CHUNK_RELOAD_KEY);
}
